import { render, staticRenderFns } from "./DefectSendModal.vue?vue&type=template&id=6626a1b3&"
import script from "./DefectSendModal.vue?vue&type=script&lang=js&"
export * from "./DefectSendModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports